import React, { useEffect, useState } from "react";
import "./Inner_Footer_Text_Component.css";
import { ApSetup } from "../../../utils/apis/master/Master";

const Inner_Footer_Text_Component = () => {
  const [appSetup, setAppSetup] = useState([]);
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();
  const getAppSetup = async () => {
    const res = await ApSetup();
    if (res?.success) {
      setAppSetup(res.data);
    }
  };

  useEffect(() => {
    getAppSetup();
  }, []);
  return (
    <section className="Inner_Footer_Text_Component">
      <p className="text_tag">
        {htmlToReactParser.parse(appSetup?.footer_content)}
      </p>
    </section>
  );
};

export default Inner_Footer_Text_Component;
